import { useOutletContext } from 'react-router-dom';
import RecurringReviews from '@/components/client/RecurringReviews';

export default function ClientReviews() {
  const { clientId } = useOutletContext();
  return (
    <div className="space-y-6" data-testid="client-reviews-page">
      <div>
        <h1 className="font-heading text-2xl text-[#2C2420] mb-1">Recurring Reviews</h1>
        <p className="text-sm text-[#5D524D]">
          Schedule and track recurring client reviews across service lines. Monthly, quarterly, semi-annual and annual cadences supported.
        </p>
      </div>
      <RecurringReviews clientId={clientId} />
    </div>
  );
}
